// src/store/index.js
import { createStore } from 'vuex';
import Swal from 'sweetalert2';

const store = createStore({
  state: {
    isLoggedIn: false,
    member_id: null,
    email: null,
    lastActivity: null,
    permissions: null,
  },
  mutations: {
    login(state) {
      state.isLoggedIn = true;
      state.lastActivity = new Date().getTime(); // 設置登入時間為最後活動時間 
      localStorage.setItem('lastActivity', state.lastActivity);
    },
    logout(state) {
      state.isLoggedIn = false;
      state.member_id = null;
      state.email = null;
      state.lastActivity = null;  // 清除 lastActivity 
      state.permissions = null;
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('member_id');
      localStorage.removeItem('email');
      localStorage.removeItem('lastActivity');  // 清除 lastActivity 
      localStorage.removeItem('permissions');
    },
    checkLoginStatus(state) {
      state.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
      state.member_id = localStorage.getItem('member_id');
      state.email = localStorage.getItem('email');
      state.lastActivity = localStorage.getItem('lastActivity');
      state.permissions = localStorage.getItem('permissions');
    },
    setMemberId(state, { member_id, email, permissions }) {
      state.member_id = member_id;
      state.email = email;
      state.permissions = permissions;
    },
    updateLastActivity(state) {
      state.lastActivity = new Date().getTime();
      localStorage.setItem('lastActivity', state.lastActivity);
    }
  },
  actions: {
    login({ commit }, { member_id, email, permissions }) {
      commit('login');
      commit('setMemberId', { member_id, email, permissions });
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('member_id', member_id);
      localStorage.setItem('email', email);
      localStorage.setItem('permissions', permissions);
    },
    logout({ commit }) {
      commit('logout');
    },
    checkLoginStatus({ commit, dispatch, state }) {
      commit('checkLoginStatus');

      // 獲取當前時間
      const currentTime = new Date().getTime();

      // 檢查用戶是否超時
      const timeout = 60 * 60 * 1000; // 10分鐘
      if (state.isLoggedIn && state.lastActivity && (currentTime - state.lastActivity) > timeout) {
        dispatch('logout');
        Swal.fire({
          title: '登入時間已達1小時',
          text: '已自動登出，請重新登入',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
      }
    },
    updateLastActivity({ commit }) {
      commit('updateLastActivity');
    }

  },
});

export default store;
